export default "__VITE_ASSET__x60af2g7TqorFcgQlznxPQ__";